import React, { useState, useEffect } from "react";
import useFormContext from "./useFormContext.js";
import { PillsInput, Pill, Combobox, useCombobox } from '@mantine/core';
import axios from 'axios';
import { EVENTS_BASE_URL, GUEST_ADMIN, GUEST_MLT } from "../ApiDetails.js";

const Guests = () => {
  const {
    errors,
    eventFormData,
    handleChange,
    nonEditable,
    handleNonEditableUI,
    fetchfamilyUsers,
    fetchMLTUsers,
    familyUsers,
    MLTUsers,
    selectFamilyGuest,
    removeFamilyGuest,
    selectMltGuest,
    removeMltGuest
  } = useFormContext();

  const [guestDetails, setGuestDetails] = useState({
    guests: [],
    SeatsRequired: 0,
    UnderReview: 0,
    Confirmed: 0,
    MaxUsersCount: 0,
    IsMaxCount: false
  });

  useEffect(() => {
    fetchfamilyUsers();
    fetchMLTUsers();
  }, []);

  useEffect(() => {
    if (eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') {
      fetchGuests();
    } else {
      setValue(eventFormData.mltEvent ? eventFormData.mlt : eventFormData.mem);
    }
  }, []);

  const fetchGuests = async () => {
    await axios.get(`${EVENTS_BASE_URL}/${eventFormData.eventId}/${eventFormData.mltEvent ? GUEST_MLT : GUEST_ADMIN}`)
      .then(response => {
        if (response.data.guests !== null) {
          var guestDetails = {};
          guestDetails.SeatsRequired = response.data.seatsRequired;
          guestDetails.UnderReview = response.data.underReview;
          guestDetails.Confirmed = response.data.confirmed;
          guestDetails.MaxUsersCount = eventFormData.mltEvent ? eventFormData.mltNum : eventFormData.familyNum;
          guestDetails.guests = response.data.guests.map(function (guest) {
            return {
              'id': guest.userId,
              'name': guest.fullname,
              'status': guest.status
            };
          });
          setGuestDetails(guestDetails);
        }
      });
  }

  useEffect(() => {
    if (nonEditable) {
      handleNonEditableUI();
    }
  }, [nonEditable]);

  // Inline styles for the tooltip
  const tooltipStyle = {
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer'
  };

  const tooltipTextStyle = {
    visibility: 'hidden',
    width: '300px',
    backgroundColor: 'darkblue',
    color: '#fff',
    textAlign: 'center',
    borderRadius: '5px',
    padding: '5px',
    position: 'absolute',
    zIndex: 1,
    bottom: '125%',
    left: '50%',
    marginLeft: '-150px',
    opacity: 0,
    transition: 'opacity 0.3s'
  };

  const tooltipHoverStyle = {
    visibility: 'visible',
    opacity: 1
  };

  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const infoIconStyle = {
    color: 'darkblue',
    marginRight: '10px', /* Adjust space to the right of the label */
    fontSize: '16px', /* Optional: Adjust size of the icon */
    cursor: 'pointer'
  };

  const InfoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" style={infoIconStyle}>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
      <line x1="12" y1="16" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="8" r="1" fill="currentColor" />
    </svg>
  );

  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
    onDropdownOpen: () => combobox.updateSelectedOptionIndex('active'),
  });

  const [search, setSearch] = useState('');
  const [value, setValue] = useState([]);

  const handleValueSelect = (guest) => {
    setValue((current) => current.includes(guest) ? current.filter((v) => v !== guest) : [...current, guest]);
    eventFormData.mltEvent ? selectMltGuest(guest) : selectFamilyGuest(guest);
  }

  const handleValueRemove = (guest) => {
    setValue((current) => current.filter((v) => v !== guest));
    eventFormData.mltEvent ? removeMltGuest(guest) : removeFamilyGuest(guest);
  }

  const values = value.map((item) => (
    <Pill key={item.id} withRemoveButton onRemove={() => handleValueRemove(item)}>
      {item.fullname}
    </Pill>
  ));

  const values_noedit = value.map((item) => (
    <Pill key={item.id} onRemove={() => handleValueRemove(item)}>
      {item.fullname}
    </Pill>
  ));

  const guests = eventFormData.mltEvent ? MLTUsers : familyUsers;
  const options = guests?.length > 0 ? guests
    .filter(guest => !value.includes(guest) && guest.fullname.toLowerCase().includes(search.trim().toLowerCase()))
    .map((guest) => (
      <Combobox.Option value={guest} key={guest.id} active={value.includes(guest)}>
        {guest.fullname}
      </Combobox.Option>
    )) : [];

  const editableContent = (
    <>
      <div className="col-md-10">
        <div className="bg-light rounded p-3 mt-3">
          <div className="form-group row mb-2 align-items-center">
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-3 col-form-label"
              id="familyNum"
            >
              {eventFormData.mltEvent === true ? (
                <> MINIMUM NUMBER OF MLT USERS REQUIRED </>
              ) : (
                <> MINIMUM NUMBER OF FAMILY MEMBERS REQUIRED </>
              )}
            </label>
            <div className="col-sm-5">
              <input
                type="number"
                min={0}
                disabled={(eventFormData.eventStatus !== 'Draft')}
                className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control"} 
                id={eventFormData.mltEvent === true ? "mltNum" : "familyNum"}
                name={eventFormData.mltEvent === true ? "mltNum" : "familyNum"}
                value={(eventFormData.mltEvent === true ? eventFormData.mltNum : eventFormData.familyNum) === "" ? 1 : (eventFormData.mltEvent === true ? eventFormData.mltNum : eventFormData.familyNum)}
                onChange={handleChange}
                placeholder={nonEditable ? "" : "Default: 1"}
              />
              {eventFormData.mltEvent ? eventFormData.mltNum < 1 && eventFormData.mltNum > 10 && (
                <div style={{ color: "red", fontSize: "13px" }}>
                  {errors.mltNum}
                </div>
              ) : (errors.maxFamNum && (
                <div style={{ color: "red", fontSize: "13px" }}>
                  {errors.maxFamNum}
                </div>
              ))}

              {eventFormData.mltEvent ? (
                errors.mltNum && (
                  <div style={{ color: "red", fontSize: "13px" }}>
                    {errors.mltNum}
                  </div>
                )
              ) : (
                errors.familyNum && (
                  <div style={{ color: "red", fontSize: "13px" }}>
                    {errors.familyNum}
                  </div>
                )
              )}
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-3 col-form-label"
            >
              {eventFormData.mltEvent === true ? (
                <> SPECIFIC MLT USER NAMES</>
              ) : (
                <> SPECIFIC FAMILY MEMBERS NAMES</>
              )}
              <div
                style={tooltipStyle}
                onMouseEnter={() => setTooltipVisible(true)}
                onMouseLeave={() => setTooltipVisible(false)}
              >
                <InfoIcon />
                <span style={{ ...tooltipTextStyle, ...(isTooltipVisible ? tooltipHoverStyle : {}) }}>
                  Are there specific family member(s) who were consulted for this event or who you expect to attend this event?
                </span>
              </div>
            </label>

            <div className="col-sm-5">
              <Combobox
                store={combobox}
                onOptionSubmit={handleValueSelect}
                >
                <Combobox.DropdownTarget>
                  <PillsInput onClick={() => { if (eventFormData.eventStatus === 'Draft') combobox.openDropdown(); }}>
                    <Pill.Group>
                      {(eventFormData.eventStatus == 'Draft') ? values : values_noedit}

                      <Combobox.EventsTarget>
                        <PillsInput.Field
                          onFocus={() => { if (eventFormData.eventStatus === 'Draft') combobox.openDropdown(); }}
                          onBlur={() => combobox.closeDropdown()}
                          value={search}
                          disabled={(eventFormData.eventStatus !== 'Draft')}
                          className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control"} 
                          placeholder={nonEditable || (eventFormData.eventStatus !== 'Draft') ? "" : (eventFormData.mltEvent === true ? "Type the MLT user names" : "Type the family member names")}
                          onChange={(event) => {
                            combobox.updateSelectedOptionIndex();
                            setSearch(event.currentTarget.value);
                          }}
                          onKeyDown={(event) => {
                            if (event.key === 'Backspace' && search.length === 0 && value.length > 0) {
                              event.preventDefault();
                              handleValueRemove(value[value.length - 1]);
                            }
                          }}
                        />
                      </Combobox.EventsTarget>
                    </Pill.Group>
                  </PillsInput>
                </Combobox.DropdownTarget>

                <Combobox.Dropdown>
                  <Combobox.Options mah={200} style={{ overflowY: 'auto' }}>
                    {options.length > 0 ? options : <Combobox.Empty>Nothing found...</Combobox.Empty>}
                  </Combobox.Options>
                </Combobox.Dropdown>
              </Combobox>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: "150px" }}></div>
    </>
  );

  const nonEditableContent = (
    <>
      <div className="main-container col-md-10">
        <div className="overview-section">
          <div className="overview">
            <span>OVERVIEW</span>
            <div className="status adminOverviewSpacing">
              <div className="status-item">
                <span className="under-review">UNDER REVIEW</span>
                <span id="UnderReviewCount" className="count">{guestDetails.UnderReview}</span>
              </div>
              <div className="status-item">
                <span className="Confirmed">CONFIRMED</span>
                <span id="ConfirmedCount" className="count">{guestDetails.Confirmed}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="family-guests">
            <div className="family-header">
              <span>{eventFormData.mltEvent ? 'MLT GUESTS' : 'MARS FAMILY GUESTS'}</span>
            </div>

            <span className="seat-request-title">NUMBER OF SEATS REQUESTED</span>
            <span id="SeatsRequiredCount" className="seat-request-count">{guestDetails.SeatsRequired}</span>

            <div className="guest-list" id="guestItem">
              {guestDetails.guests.map((guest, index) => (
                <div className="guest-item" key={index}>
                  <div className="guest-name">{guest.name}</div>
                  <div className="guest-status">
                    <span id={guest.name + 'status'} className={`card-footer-button btn rounded-pill ${guest.status}`}>
                      {guest.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ height: "100px" }}></div>
      </div>
    </>
  );

  return (eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review')
    ? nonEditableContent
    : editableContent;
};

export default Guests;